(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/game-guide-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/game-guide-service.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let jupiterHelper;
let trinidad;
if (isServer) {
  const path = require('path');
  trinidad = require('@svenskaspelab/trinidad-core').core;
  jupiterHelper = require(path.join(__dirname, 'jupiter-helper.es6'));
  logger = trinidad.logger('arena: game-guide-service');
} else {
  trinidad = svs.core;
  jupiterHelper = svs.arena.service.jupiterHelper;
  logger = svs.arena.logger;
}


const getCmsDataFolderAsync = async parentId => {
  const options = {
    method: 'GET',
    path: new svs.content.shared.ContentUrlBuilder('basicfilter').addParams({
      parentId,
      count: 20,
      sortOrder: 'desc'
    }).build()
  };
  logger.debug('Call to getCmsDataFolderAsync with options: ', options);
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  logger.debug('Call to getCmsDataFolderAsync response data, error: ', data, error);
  return {
    data: data || [],
    error
  };
};

const getCmsDataDocumentAsync = async id => {
  const options = {
    method: 'GET',
    path: new svs.content.shared.ContentUrlBuilder('id').addParams({
      ids: [id],
      count: 100
    }).build()
  };
  logger.debug('Call to getCmsDataDocumentAsync with options: ', options);
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return {
    data: data || [],
    error
  };
};

const getCmsDataDocumentsAsync = async idList => {
  const options = {
    method: 'GET',
    path: new svs.content.shared.ContentUrlBuilder('id').addParams({
      ids: idList,
      count: 100
    }).build()
  };
  logger.debug('Call to getCmsDataDocumentAsync with options: ', options);
  const {
    data,
    error
  } = await jupiterHelper.streamlinedJupiterCall(options);
  return {
    data: data || [],
    error
  };
};
const exportedFunctions = {
  getCmsDataFolderAsync,
  getCmsDataDocumentAsync,
  getCmsDataDocumentsAsync
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.arena.service.gameGuideService = exportedFunctions;
}

 })(window);